import { type ReactElement } from 'react'

interface Props {
  message?: string
}

export function FieldError ({ message }: Props): ReactElement | null {
  if (message == null || message === '') return null
  return (
    <div className='text-[11px] text-destructive mt-1'>
      {message}
    </div>
  )
}
